import Vue from 'vue'
import App from './App.vue'
import router from './router'
import directive from './directive'

//Vue.use()是Vue提供的全局Api，专门用于安装Vue插件
Vue.use(directive)

Vue.config.productionTip = false

//Vue应用的核心启动代码（Vue.js 应用的入口点），它创建一个新的Vue实例并将其挂载在DOM元素上
new Vue({
    router, // 挂载路由
    render: h => h(App)
}).$mount('#app')
